import { Certificate } from '@revenuemarket/bank';
import { HomeTax, Tooltip } from '@revenuemarket/ui';
interface Props {
  certificate: Certificate;
}

const HomeTaxRenderer: React.FC<Props> = ({ certificate }) => {
  return certificate.organizationList.find((org) => org.organizationDataCategory === 'REVENUE') ? (
    <>
      <button
        style={{
          backgroundColor: 'transparent',
        }}
        data-tip
        data-for="certificate-tax-invoice"
      >
        <HomeTax />
      </button>
      <Tooltip id="certificate-tax-invoice" effect="solid" place={'top'} padding="4px 8px">
        홈택스
      </Tooltip>
    </>
  ) : (
    <div />
  );
};

export default HomeTaxRenderer;
